import React, { FC } from 'react';
import { DynamicComponent, BackToTop, Seo } from '@/components';
import { TypeProductLandingPage } from '@/core/generated-types';
import { buildCanonicalUrl } from '@/core/contentfulConfig';

export const ProductLandingPageLayout: FC<TypeProductLandingPage> = (page) => {
  const {
    fields: { title, components, description },
  } = page;
  const metadataFields = page.fields?.seoMetadata?.fields;

  return (
    <>
      <Seo
        title={metadataFields?.pageTitle}
        description={metadataFields?.pageDescription}
        nofollow={metadataFields?.noFollow}
        noindex={metadataFields?.noIndex}
        canonical={buildCanonicalUrl(page)}
      />
      <div className="overflow-hidden">
        {title && (
          <h1 className="container mx-auto mt-8 text-center text-d-h2 font-bold">
            {title}
          </h1>
        )}
        {description && <p className="container mx-auto">{description}</p>}
        <div>
          {components &&
            components.map((component) => (
              <DynamicComponent key={component.sys.id} component={component} />
            ))}
        </div>
      </div>
      <BackToTop />
    </>
  );
};
